import { ingenuity } from "@quest/base-core";
import { Model, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";

export class BaseGameModel extends Model {
  private noWinAnimationSequence: string[] = [];
  private noWinSequenceCounter: number = 0;
  /**
   * Overrided to add the cascade feature in animation sequenece
   * @param serverModel
   */
  constructor(serverModel: any) {
    super(serverModel);
    this.setAnimationSequence(["showCascading", "collectSpecial", "moneyHunting", "clueRevealed","clueRewardMsgBanner","clueRewardCollection","showGrandJP","bigWin", "triggeringAnimation", "freeSpin", "sendCloseRequest"]);
    this.setNoWinAnimationSequence(["collectSpecial","clueRevealed","sendCloseRequest"]);
  }

  public getWinMeterTickUpDuration(evt?: number): number {
    const winAmount: number = evt ? evt : this.getCurrentWinAmt();
    if ((ingenuity.parserModel as GameParserModel).getCascadingCount() !== 0) {
      if (this.getIsTurboModeOn()) {
        return SlotConstantsBehavior.WINTICKUP_BG_3;
      } else {
        return SlotConstantsBehavior.WINTICKUP_BG_1;
      }
    } else {
      if (this.getIsBigWin()) {
        if (
          winAmount >= this.getTotalBet() * gameConstants.BigWinMultiplier &&
          winAmount < this.getTotalBet() * gameConstants.SuperWinMultiplier
        ) {
          return gameConstants.WINTICKUP_22;
        } else if (
          winAmount >= this.getTotalBet() * gameConstants.SuperWinMultiplier &&
          winAmount < this.getTotalBet() * gameConstants.EpicWinMultiplier
        ) {
          return gameConstants.WINTICKUP_22;
        } else if (
          winAmount >= this.getTotalBet() * gameConstants.EpicWinMultiplier &&
          winAmount < this.getTotalBet() * gameConstants.CrazyWinMultiplier
        ) {
          return gameConstants.WINTICKUP_22;
        } else if (winAmount >= this.getTotalBet() * gameConstants.CrazyWinMultiplier) {
          return gameConstants.WINTICKUP_22;
        }
      }
    }
  }

  /**
   * Method is overrided to add @SupreWin , @EpicWin , @CrazyWin
   * @param winAmount
   * @returns
   */
  getIsBigWin(winAmount?: number): number {
    let win = winAmount !== undefined ? winAmount : (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getclueRevealedWinAmt();
    const currBet = this.serverModel.getCurrentTotalBet();

    if (win >= currBet * gameConstants.CRAZY_WIN_MULTIPLIER) {
      return gameConstants.CRAZY_WIN;
    } else if (win >= currBet * gameConstants.EPIC_WIN_MULTIPLIER) {
      return gameConstants.EPIC_WIN;
    } else if (win >= currBet * gameConstants.SUPER_WIN_MULTIPLIER) {
      return gameConstants.SUPER_WIN;
    } else if (win >= currBet * gameConstants.BIG_WIN_MULTIPLIER) {
      return gameConstants.BIG_WIN;
    } else {
      return gameConstants.NO_WIN;
    }
  }

  public setNoWinAnimationSequence(data: string[]): void {
    this.noWinAnimationSequence = data;
  }
  public getNoWinAnimationSequence(): string[] {
    return this.noWinAnimationSequence;
  }
  public setNoWinSequenceCounter(data: number): void {
    this.noWinSequenceCounter = data;
  }
  public getNoWinSequenceCounter(): number {
    return this.noWinSequenceCounter;
  }

  public updateNoWinSequenceCounter(): void {
    this.noWinSequenceCounter++;
  }
}
